import useMobile from "customHooks/useMobile";
import useTranslation from "next-translate/useTranslation";
import { memo } from "react";
import { Controller, useFormContext } from "react-hook-form";

const Step4 = () => {
  const { control } = useFormContext();
  const { t } = useTranslation("common");
  const isMobile = useMobile("md");
  return (
    <div className="mb-3">
      <div className={`fs-${isMobile ? "md" : "lg"} mb-3`}>
        <span className="fw-medium text-heading">
          {t("event_privacy_question")}{" "}
        </span>
      </div>
      <div className="row gx-2">
        <Controller
          control={control}
          name={"private"}
          render={({ field: { onChange, onBlur, value, ref } }) => {
            return (
              <>
                <div className="col-6">
                  <div className="form-check form-option form-option-size form-check-inline flex-1 d-block px-0 m-0">
                    <input
                      type="radio"
                      onBlur={onBlur} // notify when input is touched
                      onChange={() => onChange(true)} // send value to hook form
                      checked={value === true}
                      ref={ref}
                      className="form-check-input"
                      name="private"
                      id="yes"
                      hidden
                    />
                    <label htmlFor="yes" className="form-option-label w-100">
                      {t("yes")}
                    </label>
                  </div>
                </div>

                <div className="col-6">
                  <div className="form-check form-option form-option-size form-check-inline flex-1 d-block px-0 m-0">
                    <input
                      type="radio"
                      hidden
                      className="form-check-input"
                      onBlur={onBlur} // notify when input is touched
                      onChange={() => onChange(false)} // send value to hook form
                      checked={value === false}
                      ref={ref}
                      name="private"
                      id="no"
                    />
                    <label htmlFor="no" className="form-option-label w-100">
                      {t("no")}
                    </label>
                  </div>
                </div>
              </>
            );
          }}
        />
      </div>
    </div>
  );
};

export default memo(Step4);
